export const formatTimerToMmSs = (totalSeconds: number) => {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const mm = Math.floor(safe / 60);
  const ss = safe % 60;

  const mmStr = String(mm).padStart(2, '0');
  const ssStr = String(ss).padStart(2, '0');

  return `${mmStr}:${ssStr}`;
};
